export const _SUCCESS = "_SUCCESS";
export const _FAILURE = "_FAILURE";
export const FETCH_CO_OPERATIONS_OLD_REQUEST = "FETCH_CO_OPERATIONS_OLD_REQUEST";
